import { createSlice, PayloadAction } from "@reduxjs/toolkit";
type NullableNumberString = number | string | null;
export interface WMSLatLngToolTipType {
  area: NullableNumberString;
  gridID: NullableNumberString;
  policies: NullableNumberString;
  premium: NullableNumberString;
  sum_insured: NullableNumberString;
}

interface State {
  isLoading: boolean;
  error?: string;
  stateGridViewStore: any;
  markersStore: any;
  districtGridStore: any;
  stateTableData: null | [];
  stateViewData: any;
  legendValues: any;
  cropData: any[];
  pospData: any;
  pospTargetData: any;
  selectedGeometry: any;
  selectedCountryGeometry: any;
  gridLatLng: any;
  computedDate: string | null;
}

const initialState: State = {
  isLoading: false,
  stateGridViewStore: {},
  markersStore: [],
  districtGridStore: {},
  stateTableData: null,
  stateViewData: [],
  legendValues: {},
  cropData: [],
  pospData: [],
  pospTargetData: [],
  selectedGeometry: null,
  selectedCountryGeometry: null,
  gridLatLng: null,
  computedDate: null,
};

export const mapApiSlice = createSlice({
  name: "mapApiSlice",
  initialState,
  reducers: {
    startLoading(state: State) {
      state.isLoading = true;
    },
    stopLoading(state: State) {
      state.isLoading = false;
    },
    hasError(state: State, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    handleStoreStateGridView(state: State, action: PayloadAction<any>) {
      state.isLoading = false;
      state.stateGridViewStore = action.payload;
      state.markersStore = [];
    },

     handleStoreMarkers(state: State, action: PayloadAction<{ marker: any; res: any }>) {
      state.isLoading = false;
      const { marker, res } = action.payload;
      const existingMarkerIndex = state.markersStore.findIndex((m: any) => m.marker === marker);
    
      if (existingMarkerIndex !== -1) {
        // Update the existing marker's res
        state.markersStore[existingMarkerIndex].res = res;
      } else {
        // Add the new marker to the store
        state.markersStore.push({ marker, res });
      }
    }, 
    handleStoreDistrictGrids(state: State, action: PayloadAction<any>) {
      state.isLoading = false;
      state.districtGridStore = action.payload;
    },
    handleStateData(state: State, action: PayloadAction<any>) {
      state.stateTableData = action.payload;
    },
    handleStateSelectedGeometry(state: State, action: PayloadAction<any>) {
      if (action.payload?.error) {
        state.selectedGeometry = null;
      } else {
        state.selectedGeometry =
          action.payload?.features[0]?.geometry.coordinates[0];
      }
    },
    handleCountrySelectedGeometry(state: State, action: PayloadAction<any>) {
      if (action.payload?.error) {
        state.selectedCountryGeometry = null;
      } else {
        state.selectedCountryGeometry =
          action.payload?.features[0]?.geometry.coordinates[0];
      }
    },
    handleStateViewData(state: State, action: PayloadAction<any>) {
      state.isLoading = false;
      state.stateViewData = action.payload;
      state.legendValues = action.payload?.min_max;
    },
    updateLegendValue(state, action) {
      state.legendValues = action.payload;
    },
    handleCropData(state: State, action: PayloadAction<any>) {
      state.isLoading = false;
      state.cropData = action.payload;
    },
    handlePOSPCount(state: State, action: PayloadAction<any>) {
      state.pospData = action.payload;
    },
    handlePOSPTarget(state: State, action: PayloadAction<any>) {
      state.pospTargetData = action.payload?.data;
    },
    handleStateGridLatLng(state: State, action: PayloadAction<any>) {
      state.gridLatLng =
        action.payload && action.payload?.features[0]
          ? action.payload?.features[0]
          : null;

      const geometryData: any[] = [];
      const coordinates =
        action.payload?.features[0]?.geometry?.coordinates[0][0] || null;
      coordinates?.forEach((element: any) => {
        const latLng: any[] = [];
        latLng.push(element[1]);
        latLng.push(element[0]);
        geometryData.push(latLng);
      });
      state.selectedGeometry = geometryData;
    },
    clearMarkers(state: State) {
      state.isLoading = false;
      state.markersStore = [];
      state.stateTableData = [];
    },
    setComputedDate(state: State, action: PayloadAction<any>) {
      state.computedDate = action?.payload?.data
    },
  },
});

export const {
  startLoading,
  stopLoading,
  hasError,
  handleStoreStateGridView,
  handleStoreMarkers,
  handleStateData,
  handleStoreDistrictGrids,
  clearMarkers,
  handleStateViewData,
  handlePOSPTarget,
  handleCropData,
  handlePOSPCount,
  handleStateSelectedGeometry,
  handleCountrySelectedGeometry,
  handleStateGridLatLng,
  updateLegendValue,
  setComputedDate,
} = mapApiSlice.actions;
export default mapApiSlice.reducer;
